<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="visit.id === null">{{ 'NEWVISIT' | translate }}</span>
            <span *ngIf="visit.id !== null">{{ 'EDITVISIT' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="visitForm" id="visitForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="visitForm" >
            <input type="hidden" name="id" id="visitId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="visitIp" formControlName="ip" type="text" pInputText [required]="true"> 
                      <label for="visitIp" class="req">{{ 'IP' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="visitForm.controls['ip'].invalid && (visitForm.controls['ip'].dirty || visitForm.controls['ip'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="visitForm.controls['ip'].errors !== null">
                  <div *ngIf="visitForm.controls['ip'].errors.required">
                   {{ 'IPREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="visitIsValid" formControlName="isValid" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="visitIsValid" class="p-d-inline-block p-ml-2 req">{{ 'ISVALID' | translate }}</label>
                </div>
                <div *ngIf="visitForm.controls['isValid'].invalid && (visitForm.controls['isValid'].dirty || visitForm.controls['isValid'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="visitForm.controls['isValid'].errors !== null">
                  <div *ngIf="visitForm.controls['isValid'].errors.required">
                   {{ 'ISVALIDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <span class="p-float-label">
                    <textarea id="visitUserAgent" formControlName="userAgent" [rows]="5" [cols]="30" pInputTextarea [autoResize]="true" [required]="true"></textarea>
                    <label for="visitUserAgent" class="req">{{ 'USERAGENT' | translate }}</label>
                  </span>
                </div>
                <div *ngIf="visitForm.controls['userAgent'].invalid && (visitForm.controls['userAgent'].dirty || visitForm.controls['userAgent'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="visitForm.controls['userAgent'].errors !== null">
                  <div *ngIf="visitForm.controls['userAgent'].errors.required">
                   {{ 'USERAGENTREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKVISITS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="visit.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!visitForm.valid || disableSubmit"> <!--  [disabled]="visitForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!visitForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

